import { Trans } from '@lingui/macro'

import styles from './SizeGuide.module.scss'
import measurementsImage from './sizetable.jpeg'
import Heading from '../../typography/Heading'

export const MeasurementsInfo = () => (
    <div className={styles.measurements} data-uid="measurements">
        <div className={styles.header}>
            <Heading variant="h3" element="h3">
                <Trans id="sizetable.measurements.info.header1">
                    Measurements table
                </Trans>
            </Heading>
        </div>
        <div className={styles.header}>
            <Heading variant="h4" element="h4">
                <Trans id="sizetable.measurements.info.header2">
                    Measurements table
                </Trans>
            </Heading>
        </div>

        <div className={styles.row}>
            <div className={styles.col}>
                <img src={measurementsImage} style={{ flexGrow: 0 }} />
            </div>
        </div>
        <div className={styles.row}>
            <div className={styles.measurementsTable}>
                <div>
                    <span className={styles.measurementTitle}>
                        <Trans id="sizetable.measurements.info.chest.header">
                            Chest:
                        </Trans>
                    </span>
                    <span>
                        <Trans id="sizetable.measurements.info.chest.text">
                            Measure at the widest part of your chest, 2cm below
                            the armpits
                        </Trans>
                    </span>
                </div>
                <div>
                    <span className={styles.measurementTitle}>
                        <Trans id="sizetable.measurements.info.waist.header">
                            Waist:
                        </Trans>
                    </span>
                    <span>
                        <Trans id="sizetable.measurements.info.waist.text">
                            Measure at the widest part of your waist, 2cm below
                            the armpits
                        </Trans>
                    </span>
                </div>
                <div>
                    <span className={styles.measurementTitle}>
                        <Trans id="sizetable.measurements.info.waist.jeans.header">
                            Waist jeans:
                        </Trans>
                    </span>
                    <span>
                        <Trans id="sizetable.measurements.info.waist.jeans.text">
                            Measure at the widest part of your waist/jeans, 2cm
                            below the armpits
                        </Trans>
                    </span>
                </div>
                <div>
                    <span className={styles.measurementTitle}>
                        <Trans id="sizetable.measurements.info.neck.header">
                            Neck:
                        </Trans>
                    </span>
                    <span>
                        <Trans id="sizetable.measurements.info.neck.text">
                            Measure at the widest part of your neck, 2cm below
                            the armpits
                        </Trans>
                    </span>
                </div>
                <div>
                    <span className={styles.measurementTitle}>
                        <Trans id="sizetable.measurements.info.sleeve.header">
                            Sleeve length:
                        </Trans>
                    </span>
                    <span>
                        <Trans id="sizetable.measurements.info.sleeve.text">
                            Measure at the widest part of your arm, 2cm below
                            the armpits
                        </Trans>
                    </span>
                </div>
                <div>
                    <span className={styles.measurementTitle}>
                        <Trans id="sizetable.measurements.info.inseam.header">
                            Inseam:
                        </Trans>
                    </span>
                    <span>
                        <Trans id="sizetable.measurements.info.inseam.text">
                            Measure at the widest part of your head, 2cm below
                            the armpits
                        </Trans>
                    </span>
                </div>
            </div>
        </div>
    </div>
)
